import { createSlice } from "@reduxjs/toolkit";
import {
  getBlogs,
  getBlogById,
  createBlog,
  updateBlog,
  deleteBlog,
} from "./blogThunks";

const initialState = {
  blogs: [],
  currentBlog: null,
  loading: false,
  error: null,

  createLoading: false,
  createSuccess: false,

  updateLoading: false,
  updateSuccess: false,

  deleteLoading: false,
  deleteSuccess: false,
};

const blogSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {
    resetBlogStatus: (state) => {
      state.createSuccess = false;
      state.updateSuccess = false;
      state.deleteSuccess = false;
      state.error = null;
    },
    clearCurrentBlog: (state) => {
      state.currentBlog = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ================= GET BLOGS =================
      .addCase(getBlogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs = action.payload;
      })
      .addCase(getBlogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= GET BLOG BY ID =================
      .addCase(getBlogById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBlogById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentBlog = action.payload?.data || action.payload;
      })
      .addCase(getBlogById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= CREATE BLOG =================
      .addCase(createBlog.pending, (state) => {
        state.createLoading = true;
        state.createSuccess = false;
        state.error = null;
      })
      .addCase(createBlog.fulfilled, (state, action) => {
        state.createLoading = false;
        state.createSuccess = true;
        const newBlog = action.payload?.data || action.payload;
        if (newBlog && Array.isArray(state.blogs?.data)) {
          state.blogs.data.unshift(newBlog);
        } else if (newBlog && Array.isArray(state.blogs)) {
          state.blogs.unshift(newBlog);
        }
      })
      .addCase(createBlog.rejected, (state, action) => {
        state.createLoading = false;
        state.error = action.payload;
      })

      // ================= UPDATE BLOG =================
      .addCase(updateBlog.pending, (state) => {
        state.updateLoading = true;
        state.updateSuccess = false;
        state.error = null;
      })
      .addCase(updateBlog.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateSuccess = true;
        const updated = action.payload?.data || action.payload;
        if (updated?.id) {
          if (Array.isArray(state.blogs?.data)) {
            state.blogs.data = state.blogs.data.map((item) =>
              item.id === updated.id ? updated : item,
            );
          } else if (Array.isArray(state.blogs)) {
            state.blogs = state.blogs.map((item) =>
              item.id === updated.id ? updated : item,
            );
          }
        }
      })
      .addCase(updateBlog.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
      })

      // ================= DELETE BLOG =================
      .addCase(deleteBlog.pending, (state) => {
        state.deleteLoading = true;
        state.deleteSuccess = false;
      })
      .addCase(deleteBlog.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.deleteSuccess = true;
        const deletedId = action.payload;
        if (Array.isArray(state.blogs?.data)) {
          state.blogs.data = state.blogs.data.filter((item) => item.id !== deletedId);
        } else if (Array.isArray(state.blogs)) {
          state.blogs = state.blogs.filter((item) => item.id !== deletedId);
        }
      })
      .addCase(deleteBlog.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetBlogStatus, clearCurrentBlog } = blogSlice.actions;
export default blogSlice.reducer;
